var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-3":"spread-block-contour","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('defs'),_c('g',{attrs:{"id":"Контур"}},[_c('rect',{staticClass:"lc-c-3",attrs:{"x":"66.88","y":"147.83","width":"379.73","height":"138.91","rx":"12"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }